export default "__VITE_ASSET__33079aa5__"